import { getCoreAjax } from '../../utils/moodle-amd';

export default async () => {
  const modBoard = document.querySelector('.mod_board');
  if (!modBoard) return null;

  try {
    const Ajax = await getCoreAjax();

    const userid =
      document.querySelector('#usernavigation *')?.dataset?.userid || 0;

    const cmid = Number(
      document.body.className.match(/\bcmid-(\d+)\b/)?.[1] || 0
    );

    if (!cmid) {
      console.warn('CMID not found');
      return null;
    }

    const response = await Ajax.call([
      {
        methodname: 'mod_board_get_board',
        args: {
          id: '-1',
          cmid,
          ownerid: Number(userid)
        }
      }
    ])[0];

    return response;
  } catch (err) {
    console.log(err);
    throw err;
  }

  return null;
};
